import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QueueService {
  constructor(private http: HttpClient) {}

    getQueueStats(): Observable<{ stats: { queued: number; running: number; completed: number; failed: number; cancelled: number } }> {
        return this.http.get<{ stats: { queued: number; running: number; completed: number; failed: number; cancelled: number } }>(
        '/api/queue/tasks/stats'
        );
    }

    getQueueTasks(search: string = '', page: number = 1, pageSize: number = 20): Observable<{ tasks: any[], total: number }> {
        let url = `/api/queue/tasks?page=${page}&page_size=${pageSize}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        return this.http.get<{ tasks: any[], total: number }>(url);
    }

    getTaskDetails(taskId: string): Observable<any> {
        return this.http.get<any>(`/api/queue/tasks/${taskId}`);
    }

    deleteTask(taskId: string): Observable<void> {
        return this.http.delete<void>(`/api/queue/tasks/${taskId}`);
    }

    clearOldJobsOneDayBack(): Observable<void> {
        return this.http.delete<void>('/api/queue/tasks/clear/86400');
    }
}